import React from 'react'
import { Link } from 'react-router-dom'
import { TbPhoneCall } from 'react-icons/tb'
import logo1 from '../assets/logo1.webp'
import logo2 from '../assets/logo2.webp'
import logo3 from '../assets/logo3.webp'
import logo4 from '../assets/logo4.webp'
import logo5 from '../assets/logo5.webp'
import dr1 from '../assets/dr1.webp'
import dr2 from '../assets/dr2.webp'
import dr3 from '../assets/dr3.webp'
import dr4 from '../assets/dr4.webp'

export default function Dentist() {


  return (<div>


    <div className=' bg-hero-pattern -z-10' >
      <div className=' flex justify-center items-center  flex-col bg-[rgb(59,68,152,0.9)] bg-cover bg-no-repeat  h-[60vh]   text-white xl:px-[9vw]  text-center   ' >
        <p
          className='text-xl tracking-wide  p-2'>DENTIST</p>
        <h1 h1 className='text-4xl lg:text-7xl p-2 tracking-wide font-semibold'>Our Specialist</h1>
        <span className='mt-2 p-3 text-xl font-sans '>
          <Link to='/home' className='hover:text-gray-400'>Home</Link> / Dentist
        </span>
      </div>
    </div>

    <div className='grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 justify-center xl:px-[9vw]   items-center '>
      <div className='m-4  pb-4 ' >
        <img src={dr1} alt="" className='' />
        <p className='my-2 font-sans text-green-700 m-4' >Dr. Rebeca Smith
        </p>
        <p className='text-blue-900 border-b-2 m-4 pb-4' >Dental Sergeon
        </p>
        <div className='flex gap-5 justify-between mx-4' >
          <div className='flex gap-5 ' >
            <span>
              10 am - 04 pm
            </span></div>
          <TbPhoneCall className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
        </div>
      </div>
      <div className='m-4  pb-4' >
        <img src={dr2} alt="" />
        <p className='my-2 font-sans text-green-700 m-4' >Dr. Julia Smith</p>
        <p className='text-blue-900 border-b-2 m-4 pb-4' >Orthodontist</p>
        <div className='flex gap-5 justify-between mx-4' >
          <div className='flex gap-5 ' >
            <span>
              10 am - 04 pm
            </span></div>
          <TbPhoneCall className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
        </div>
      </div>
      <div className='m-4  pb-4' >
        <img src={dr3} alt="" />
        <p className='my-2 font-sans text-green-700 m-4' >Dr. David Costa</p>
        <p className='text-blue-900 border-b-2 m-4 pb-4' >Dental Sergeon
        </p>
        <div className='flex gap-5 justify-between mx-4' >
          <div className='flex gap-5 ' >
            <span>
              10 am - 04 pm
            </span></div>
          <TbPhoneCall className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
        </div>
      </div>
      <div className='m-4  pb-4' >
        <img src={dr4} alt="" />
        <p className='my-2 font-sans text-green-700 m-4' >Dr. Andrew Rassel</p>
        <p className='text-blue-900 border-b-2 m-4 pb-4' >Orthodontist</p>
        <div className='flex gap-5 justify-between mx-4' >
          <div className='flex gap-5 ' >
            <span>
              10 am - 04 pm
            </span></div>
          <TbPhoneCall className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
        </div>
      </div>
      <div className='m-4  pb-4 ' >
        <img src={dr1} alt="" className='  ' />
        <p className='my-2 font-sans text-green-700 m-4' >Dr. Rebeca Smith
        </p>
        <p className='text-blue-900 border-b-2 m-4 pb-4' >Dental Sergeon
        </p>
        <div className='flex gap-5 justify-between mx-4' >
          <div className='flex gap-5 ' >
            <span>
              10 am - 04 pm
            </span></div>
          <TbPhoneCall className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
        </div>
      </div>
      <div className='m-4  pb-4' >
        <img src={dr2} alt="" />
        <p className='my-2 font-sans text-green-700 m-4' >Dr. Julia Smith</p>
        <p className='text-blue-900 border-b-2 m-4 pb-4' >Orthodontist</p>
        <div className='flex gap-5 justify-between mx-4' >
          <div className='flex gap-5 ' >
            <span>
              10 am - 04 pm
            </span></div>
          <TbPhoneCall className='justify-self-end bg-green-700 rounded-full m-2 h-8 w-8 p-2 ' />
        </div>
      </div>
    </div>

    <div className='grid grid-cols-1 justify-center gap-10 text-center lg:text-left sm:grid-cols-2 m-4 my-10 xl:px-[9vw]'>
      <div>
        <p className='text-[#009640] text-2xl tracking-wide'>PARTNERS</p>
        <h1 className=' text-4xl lg:text-5xl font-semibold  sm:mt-5 text-blue-900 tracking-wider py-3 ' >Our  <span className='text-[#009640]'>Partners </span>  <br /> <span className='text-[#009640]'>love </span> to work</h1>
        <p className='font-sans my-1' >Dental care is the maintenance teeth the practice of keeping mouth clean sue pleasure rationally encounter</p>
        <p>Albert Rusho (Root Canals)</p>
      </div>
      <div className='flex flex-wrap my-10 gap-10 justify-evenly items-center ' >
        <img src={logo1} alt="logo1" />
        <img src={logo2} alt="logo1" />
        <img src={logo3} alt="logo1" />
        <img src={logo4} alt="logo1" />
        <img src={logo5} alt="logo1" />
      </div>
    </div>

    <div className="flex flex-col sm:flex-row text-white px-5 justify-between lg:px-28 py-10 bg-[#009640] ">
      <div> <p className=' text-2xl tracking-wide'>NEWSLETTER</p>
        <h1 className=' text-4xl lg:text-5xl font-semibold  sm:mt-3 tracking-wide py-3 ' > Subscribe our Newsletter</h1></div>
      <div>
        <input type="text" className='p-2 bg-transparent sm:-ml-6 h-10 text-white font-sans border-2 border-white' placeholder=' Enter Your Email Address' /><button className='bg-[rgb(63,65,153)]  font-sans h-10 px-2' >Subscribe</button>
      </div>
    </div>

  </div>
  )
}
